import { useLang } from "../context/LangContext";

const COLORS = {
  potassium: "var(--rs-potassium)",
  phosphorus: "var(--rs-phosphorus)",
  sodium: "var(--rs-sodium)",
  protein: "var(--rs-protein)",
  water: "var(--rs-water)",
};

export default function NutrientCard({ nutrientKey, value, limit, unit = "mg", icon: Icon }) {
  const { t } = useLang();
  const pct = limit > 0 ? Math.min(100, (value / limit) * 100) : 0;
  const exceeded = value > limit;
  const color = COLORS[nutrientKey] || "var(--rs-primary)";
  return (
    <div className="bento-card" data-testid={`nutrient-${nutrientKey}`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          {Icon && (
            <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: `${color}22` }}>
              <Icon className="w-5 h-5" style={{ color }} />
            </div>
          )}
          <h3 className="font-semibold text-base">{t(nutrientKey)}</h3>
        </div>
        <span
          className={`text-xs font-semibold px-2 py-1 rounded-full ${
            exceeded ? "bg-destructive/10 text-destructive" : "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400"
          }`}
          data-testid={`nutrient-${nutrientKey}-status`}
        >
          {exceeded ? t("exceeded") : t("safe")}
        </span>
      </div>
      <div className="mb-2">
        <div className="flex items-baseline gap-1">
          <span className="text-3xl font-extrabold" style={{ fontFamily: "IBM Plex Sans", color }}>
            {Math.round(value * 10) / 10}
          </span>
          <span className="text-sm text-muted-foreground">/ {limit} {unit}</span>
        </div>
      </div>
      <div className="nutrient-progress" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <span style={{ width: `${pct}%`, background: color }} />
      </div>
      <div className="mt-2 text-xs text-muted-foreground">
        {Math.round(pct)}% {t("of")} {t("limit")}
      </div>
    </div>
  );
}
